<template>
    <div id="app">
        <Menu />
        <router-view :key="$route.fullPath" />
        <Footer />
        <Loader />
        <transition />
        <div id="transition-cover-helper" class="transition-cover-helper"></div>
        <div ref="webgl-main-container" class="webgl-main-container"></div>
        <div
            ref="webgl-header-main-container"
            class="webgl-header-main-container"
        ></div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import Menu from "@/components/layout/menu";
import Footer from "@/components/layout/footer";
import Loader from "@/components/layout/loader";

import Transition from "@/transitions/transition";

import WebglHeaderScene from "@/glxp/scenes/headerScene";
import WebglManager from "@/glxp/webglManager";

import RAF from "@/js/utils/raf";

export default {
    name: "App",
    components: {
        Menu,
        Footer,
        Loader,
        Transition,
    },
    computed: {
        ...mapGetters(["options"]),
    },
    created() {
        this.parseUserAgent();
        this.loadOptions();

        // Fix history back behavior
        if ("scrollRestoration" in history)
            history.scrollRestoration = "manual";
        // Fix plyr not muted on reload
        window.localStorage.removeItem("plyr");
    },
    mounted() {
        window.addEventListener("resize", this.resize);
        this.resize();

        this.$nextTick(() => {
            this.headerScene = new WebglHeaderScene(
                this.$refs["webgl-header-main-container"],
            );
            this.headerScene.mobile =
                this.$store.state.ua.platform.type !== "desktop";
            this.glxpManager = WebglManager.init(
                this.$refs["webgl-main-container"],
            );
            this.glxpManager.mobile =
                this.$store.state.ua.platform.type !== "desktop";
            RAF.suscribe(
                "webgl-header-main",
                this.headerScene.render.bind(this.headerScene),
            );
            RAF.suscribe(
                "webgl-main",
                this.glxpManager.render.bind(this.glxpManager),
            );
        });
    },
    methods: {
        ...mapActions(["parseUserAgent", "loadOptions"]),
        resize() {
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty("--vh", `${vh}px`);
        },
    },
};
</script>

<style src="./styles/layout.less" lang="less"></style>
